import { THEME_ALIASES } from '@neptune/shared/venus-domain';

export function applyTheme(element: HTMLElement, theme: string) {
  if (theme === THEME_ALIASES.BROWSER) {
    element.removeAttribute('data-theme');
  } else {
    element.setAttribute('data-theme', theme);
  }
}
